import Actions from '../../components/Panel/Shops/Actions.vue';
import Online from '../../components/Panel/Shops/Online.vue';
import Pages from '../../components/Panel/Shops/Pages.vue';
import Icon from '../../components/Panel/Shops/Icon.vue';
const { VUE_APP_XPCK = 'noidkey', VUE_APP_API_URL = 'https://noid-api.printcube.app' } = process.env;

/**
 * @constant State of orders store
 * @type {object}
* */
const state = {
    cubes: false,
    shops: {},
    auth: {},
    onStorePage: 10,
    currentStorePage: 1,
    xPck: VUE_APP_XPCK,
    apiUrl: VUE_APP_API_URL,
    paginationSchema: {
        per_page: 'limit',
        total: 'count',
        current_page: 'page'
    },
    querySchema: {
        direction: 'orderBy',
        sortField: 'sortBy',
        currentPage: 'page',
        perPage: 'limit'
    },
    fields: [
        { name: 'checkbox' },
        {
            name: 'iconURL',
            title: 'Icon',
            component: Icon,
            props: 'iconURL'
        },        {
            name: 'name',
            title: 'Name',
            sortField: 'name',
            searchField: 'name',
            searchTitle: 'name'
        },
        {
            name: 'address.city',
            title: 'City',
            sortField: 'city',
            searchField: 'city',
            searchTitle: 'City'
        },
        {
            name: 'address.country',
            title: 'Country',
            sortField: 'country',
            searchField: 'country',
            searchTitle: 'Country'
        },
        {
            name: 'externalID',
            title: 'ExternalID',
            sortField: 'externalID',
            searchField: 'externalID',
            searchTitle: 'ExternalID',
            formatter (value) {
                return value || 0;
              }
        },
        {
            name: 'isOnline',
            title: 'Online',
            sortField: 'isOnline',
            props: 'isOnline',
            searchField: 'isOnline',
            searchTitle: 'Online',
            component: Online,
            searchValues: [
                { title: 'all', value: '' },
                { title: 'online', value: true },
                { title: 'offline', value: false }
            ]
        },
        {
            name: 'pages',
            title: 'Pages',
            searchTitle: 'Pages',
            props: ['pages', 'isOnline'],
            component: Pages
        },
        {
            name: 'Actions',
            title: 'Actions',
            component: Actions,
            props: 'id'
        }
    ]
};
/**
 * @constant Getters
 * @type {object}
**/
const getters = {
    getCubes: (state) => state.cubes,
    getOnPageStore: (state) => state.onStorePage,
    getCurrentStorePage: (state) => state.currentStorePage,
    getFilters: (state) => state.filters,
    getAuth: (state) => state.auth,
    getFields: (state) => state.fields,
    getPaginationSchema: (state) => state.paginationSchema,
    getQuerySchema: (state) => state.querySchema,
    getXPck: (state) => state.xPck,
    getApiUrl: (state) => state.apiUrl
};
/**
 * @constant Mutations
 * @type {object}
**/
const mutations = {
    setCubes: (state, cubes) => state.cubes = cubes,
    setAuthFromToken: (state, auth) => state.auth = auth,
    setOnPageStoreLimit: (state, onPage) => state.onStorePage = onPage,
    setCurrentStorePage: (state, currentPage) => state.currentStorePage = currentPage
};
/**w
 * @constant Actions
 * @type {object}
**/
const actions = {
    setCurrentStorePage ({ commit }, currentPage) {
        commit('setCurrentStorePage', currentPage);
    },    
    setOnPageStoreLimit ({ commit }, onPage) {
        commit('setOnPageStoreLimit', onPage);
    },
    getAuthFromToken ({ commit }) {
        const [username, password] = atob(this.state.auth.token).split(':');
        commit('setAuthFromToken', { username, password });
    },
    socket_cubes ({ commit, state }, data) {
        const stores = {};
        for (const c of Object.keys(data)) {
            data[c].name = c;
            data[c].installer = data[c].original && data[c].original.installer;
            if (stores[data[c].context]) {
                stores[data[c].context].list.push(data[c]);
            } else {
                stores[data[c].context] = {
                    list: [data[c]]
                };
            }
        }
        commit('setCubes', stores);
    }
};
export default {
    state,
    getters,
    mutations,
    actions
};
